module.exports = __webpack_public_path__ + "img/new4-img6.1c40e483.png";